import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';

import {
  Grid,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Card,
  CardActions,
  Divider,
  CardContent,
  CardHeader 
} from '@material-ui/core'

import {Folder, Delete, Star} from '@material-ui/icons'

import moment from 'moment';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from '@material-ui/core/CircularProgress';

import {getFavoritesAPIReq, deleteFavoriteAPIReq} from 'utils/requests'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  header: {

  }
}));

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => ++value); // update the state to force render
}

let isLoading = true

const getFavorites = async (forceUpdate, history) => {
  if (isLoading){
  return getFavoritesAPIReq()
  .then((res) => {
    // console.log (res.data)
    if (res.status === 'success'){
      isLoading = false
      offers = res.data
      forceUpdate();
    } else {
      // setMessage('An error occurred')
      // setSeverity('error')
      // setOpenSnack(true)
    }
  })
}
}

let offers
const Favorites = props => {
  const { history } = props;

  const [message, setMessage] = useState('')
  const [severity, setSeverity] = useState('')
  const [openSnack, setOpenSnack] = useState(false)

  const deleteFavorite = (offer_id) => {
    return deleteFavoriteAPIReq(offer_id)
      .then((res) => {
        if (res.status === 'success'){
          refresh()
        } else {
          setMessage('An error occurred')
          setSeverity('error')
          setOpenSnack(true)
        }
    })
}

const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const classes = useStyles();

  const forceUpdate = useForceUpdate();
  getFavorites(forceUpdate, history);

  const refresh = () => {
    window.location.reload(false);
    setMessage('The offer has been successfully removed from your favorites')
    setSeverity('success')
    setOpenSnack(true)
}

console.log(offers)

  return (
    <div className={classes.root}>
      <Grid item xs={12} md={12}>
        <Card>
            <CardHeader
              title="Your bookmarked offers"
              titleTypographyProps={{"variant":"h4"}}/>
          <Divider />
          <CardContent>
          <div>
                  {isLoading && 
                  <CircularProgress disableShrink/>
                }
            </div>
          <div className={classes.demo}>
            <List dense={true}>
            {!isLoading && offers.map(offer => (
              <div>
             <ListItem>
               <ListItemAvatar>
                 <Avatar
                  src={offer.company_logo || "https://cdn-pcs.auicareerspark.com/app-assets/app-assets/def-opportunity.jpg"}
                 >
                 </Avatar>
               </ListItemAvatar>
               <ListItemText
                 primary={offer.title + ' at ' + offer.company_name}
                 secondary={'Posted ' + moment(offer.posted_date, 'YYYY-MM-DD HH:mm').fromNow()}
                 primaryTypographyProps={{"variant":"h5"}}
               />
               <ListItemSecondaryAction>
                 <Button onClick={() => history.push('/offers/' + offer.hashed_id)} variant="contained" color="primary" edge="end">
                      Check details
                 </Button>
                 <IconButton onClick={() => {deleteFavorite(offer.hashed_id)}} edge="end" aria-label="delete">
                   <Delete />
                 </IconButton>
               </ListItemSecondaryAction>
              </ListItem>
                <Divider></Divider>
              </div>
            ))}
            </List>
          </div>
          </CardContent>
          </Card>
        </Grid>
        <Snackbar
          autoHideDuration={6000}
          onClose={openSnack}
          open={openSnack}
        >
          <Alert
            onClose={openSnack}
            severity={severity}
          >
            {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

Favorites.propTypes = {
  history: PropTypes.object
};

export default withRouter(Favorites);
